import { getEnv } from "../../utils";

const config = {
    merchantUrl: 'https://web.shipbob.com'
}

const configQA = {
    merchantUrl: 'https://webstage.shipbob.dev'
}

export default () => {
    const env = getEnv()
    if (env === 'qa') {
        return configQA
    } else {
        return config
    }
};